import { withTogglePointFactory } from "@asosteam/asos-web-toggle-point-cuts";
import { pointCutPluginFactory } from "@asosteam/asos-web-toggle-point-optimizely";
import { getFeatures } from "../../../featuresStore";
import sdkInstanceProvider from "../../../../client/providers/sdkInstanceProvider";
import { logError } from "../../../../client/monitoring";

const plugin = pointCutPluginFactory({
  sdkInstanceProvider,
  getAudience: () => getFeatures()?.audience
});

const withTogglePoint = withTogglePointFactory({
  getActiveFeatures: () => getFeatures()?.decisions,
  plugins: [plugin],
  logError
});

export default withTogglePoint;
